import React from 'react';
import {useTypewriter,Cursor} from 'react-simple-typewriter'
import cosmic_image from '../resources/Cosmic Wave of Particles.png'
import {motion} from 'framer-motion'
import { Mail} from 'lucide-react'
import { FaLinkedin, FaGithub } from "react-icons/fa";
function Hero() {
    const email = "ywael000@gmail.com"
    const duration = 1.5
    const [ text ] = useTypewriter({
        words: ['Developing websites with modern technologies', 'Transforming raw unmeaningful data into insights', 'Evaluating and improving AI models to achieve optimal performance'],
        loop: true,
        typeSpeed: 70,
        deleteSpeed: 50,
        delaySpeed: 1000,
    })
    return (
        <div
            id='hero' className="relative flex flex-col justify-center filter  w-full min-h-screen bg-cover bg-no-repeat bg-center"
            style={{ backgroundImage: `url("${cosmic_image}")` }}
            >
            {/* Subtle overlay for better text contrast */}
            <div className="absolute inset-0 bg-black/40" />
            <div className="relative z-10 flex flex-col  pl-[10%] w-full">
            <motion.h1 initial={{opacity:0,x:-300}} animate={{x:0,opacity:1}} transition={{duration: duration}} className='text-[70px] max-md:text-[30px] text-[30px]  text-white font-bold'>Yousef Wael</motion.h1>
            <motion.p initial={{opacity:0,x:300}} animate={{x:0,opacity:1}} transition={{duration:duration}} className=' text-[30px] max-md:text-[20px] text-white'>Data Scientist . Frontend Web Developer</motion.p>
            <p  className='text-[20px] text-white'>{text}<Cursor/></p>
            <motion.div className='mt-5 flex gap-5'
            initial={{opacity:0,y:50}}
            animate={{opacity:1,y:0}}
            transition={{duration:duration}}
            >
                <a
                href={`https://mail.google.com/mail/?view=cm&fs=1&to=${email}`}
                target="_blank"
                rel="noopener noreferrer"
                >
                    <Mail color="red" size={32} />
                </a>
                <a href="https://www.linkedin.com/in/youssef-elsebaey-b67343326" target="_blank" rel="noopener noreferrer">
                    <FaLinkedin color="blue" size={32} />
                </a>
                <a href="https://github.com/youssef124wael" target="_blank" rel="noopener noreferrer">
                    <FaGithub color="white" size={32} />
                </a>
            </motion.div>
            </div>
        </div>
    );
}

export default Hero;
